import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { useUser } from "../../context/userContext";
import menuData from "./menuData";
import logo from "../../assets/images/logo/logo_rmbg.png";
import { ReactComponent as AccountIcon } from "../../assets/icons/account_icon.svg";
import { ReactComponent as Buldge } from "../../assets/icons/buldge_icon.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/profile_icon.svg";
import { ReactComponent as PasswordIcon } from "../../assets/icons/password_icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout_icon.svg";
import ProfileModal from "../ProfileModal/profileModal.component";
import PasswordModal from "../PasswordModal/passwordModal.component";

function MobileNavBar() {
  // const sessionToken = Cookies.get('sessionToken');
  const { userData, setUserData } = useUser();

  const [initials, setInitials] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevIsSidebarOpen) => !prevIsSidebarOpen);
    window.scrollTo({top: 0});
  };

  useEffect(() => {
    if (userData?.first_name) {
      setInitials(userData.first_name.charAt(0).toUpperCase());
    }
  }, [userData]);

  const navigate = useNavigate();

  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);
  });

  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const handleProfileOpen = () => {
    setIsMenuModalOpen(!isMenuModalOpen);
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  const handleProfileClose = () => {
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const handlePasswordModalOpen = () => {
    setIsMenuModalOpen(!isMenuModalOpen);
    setIsPasswordModalOpen(!isPasswordModalOpen);
  };

  const handlePasswordModalClose = () => {
    setIsPasswordModalOpen(!isPasswordModalOpen);
  };

  useEffect(() => {
    if (isMenuModalOpen) {
      // Disable scrolling when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Restore scrolling when modal is closed
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuModalOpen]);

  const handleSignOut = () => {
    Cookies.remove('sessionToken');
    setUserData(null);
    localStorage.removeItem('userData');
    navigate("/signin");
    navigate(0);
  };

  return (
    <div>
      <header
        className={`header top-0 left-0 z-40 flex w-full items-center bg-transparent ${
          sticky
            ? "!fixed !z-[40] !bg-white !bg-opacity-80 shadow-sticky backdrop-blur-sm !transition"
            : "absolute"
        }`}
      >
        <div className="container">
          <div className="flex lg:hidden items-center justify-between">
            <div className="flex -ml-1">
              {/* Menu Button */}
              <button
                onClick={toggleSidebar}
                className="text-white focus:outline-none"
              >
                <svg className="h-6 w-6" stroke="#3559E0" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6H20M4 12H14M4 18H9"
                  ></path>
                </svg>
              </button>

              {/* Company Logo */}
              <div className="w-36 max-w-full px-4 lg:mr-12">
                <Link
                  to="/"
                  className={`header-logo block w-full ${
                    sticky ? "py-5 lg:py-2" : "py-8"
                  } `}
                >
                  <img src={logo} alt="logo" className="w-full" />
                </Link>
              </div>
            </div>

            <div className="flex items-center justify-end min-w-fit">
              {userData?.email ? (
                <div
                  className="relative mr-2 cursor-pointer"
                  title="Account"
                  onClick={() => setIsMenuModalOpen(!isMenuModalOpen)}
                >
                  <span className="flex items-center justify-center w-6 h-6 border-2 border-black rounded-full bg-white/20 text-black">
                    {initials}
                  </span>
                  {isMenuModalOpen && userData && (
                    <>
                    <Buldge className="absolute bottom-[-12px] right-[-4px] z-[60]" />
                    <div
                      className={`absolute top-[150%] right-[-12px] flex items-center justify-center drop-shadow-[0_4px_24px_rgba(0,0,0,0.24)] z-50`}
                    >
                      <div className="relative w-[240px] bg-white p-4 rounded-md">
                        <div className="flex items-center">
                          <span className="flex items-center justify-center min-w-[48px] h-12 text-black text-xl border border-neutral-100 rounded-full bg-neutral-100">
                            {initials}
                          </span>
                          <div className="ml-2">
                            <p className="font-medium tracking-tight">
                              {userData.first_name + " " + userData.last_name}
                            </p>
                            <p className="text-gray-500 text-xs overflow-hidden max-w-[150px] overflow-ellipsis">
                              {userData.email}
                            </p>
                          </div>
                        </div>

                        <div className="mt-3 border border-neutral-100" />
                        <div className="mt-4 mx-2">
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handleProfileOpen}
                          >
                            <UserIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              View Profile
                            </p>
                          </div>
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handlePasswordModalOpen}
                          >
                            <PasswordIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              Change Password
                            </p>
                          </div>
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handleSignOut}
                          >
                            <LogoutIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              Log Out
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    </>
                  )}
                  
                </div>
              ) : (
                <Link 
                  to="/signin"
                  className="flex items-center justify-center mr-2 border-2 border-black/70 rounded-full bg-white/20">
                  <AccountIcon className="w-5 h-5 p-1" fill="black"/>
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Sidebar */}
      {isSidebarOpen && (
        <div className="lg:hidden fixed inset-0 w-full bg-black/20 z-50">
        <div className="fixed inset-0 w-[80%] md:w-1/2 bg-white transition-all ease-in-out duration-300">
          <div className="flex justify-between items-center pt-7 px-2 pb-2">
            <div className="w-36 max-w-full px-4">
              <Link to="/" className="header-logo block w-full">
                <img src={logo} alt="logo" className="w-full" />
              </Link>
            </div>
            <button onClick={toggleSidebar} className="text-white">
              <svg
                className="h-7 w-7"
                fill="none"
                stroke="black"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div className="flex flex-col items-center h-full">
            <div className="my-3 w-[90%] border-b border-primary/40" />
            <ul className="w-[90%] flex flex-col items-center">
              {menuData.map(
                (menuItem, index) =>
                  (menuItem.id !== 6 || userData?.email) && (
                    <li
                      key={menuItem.id}
                      className="w-full my-1 px-3 py-2 text-black font-semibold active:font-bold active:bg-black/10 rounded-lg"
                      onClick={() => toggleSidebar(!isSidebarOpen)}
                    >
                      <Link to={menuItem.path}>{menuItem.title}</Link>
                    </li>
                  )
              )}
            </ul>
            <div className="my-3 w-[90%] border-b border-primary/40" />
            {!userData?.email && (
              <div className="w-[90%] flex flex-col">
                <Link
                  to="/signin"
                  className="w-full my-1 py-2 font-medium text-center text-white bg-primary rounded-lg"
                  onClick={() => toggleSidebar(!isSidebarOpen)}
                >
                  Sign In
                </Link>
                <Link
                  to="/signup"
                  className="my-1 py-2 text-center font-medium text-white bg-primary rounded-md hover:bg-opacity-90 hover:shadow-signUp"
                  onClick={() => toggleSidebar(!isSidebarOpen)}
                >
                  Sign Up
                </Link>{" "}
              </div>
            )}
          </div>
        </div>
        </div>
      )}

      {/* User Profile Modal */}
      {isProfileModalOpen && userData && (
        <ProfileModal
          initials={initials}
          handleProfileClose={handleProfileClose}
        />
      )}

      {/* Change Password Modal */}
      {isPasswordModalOpen && userData && (
        <PasswordModal
          initials={initials}
          handlePasswordClose={handlePasswordModalClose}
        />
      )}
    </div>
  );
}

export default MobileNavBar;
